"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _IdeationAddColor = _interopRequireDefault(require("./IdeationAddColor"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var IdeationAddEdit = function IdeationAddEdit(props) {
  return (0, _preact.h)("div", {
    className: "ideation-modal-container ".concat(props.isLoading ? 'ideation-loading' : '')
  }, (0, _preact.h)("div", {
    className: "ideation-modal-title"
  }, (0, _preact.h)("h3", null, props.title)), props.showError ? (0, _preact.h)("div", {
    className: "alert alert-danger"
  }, "Something went wrong, please try it again later.") : null, (0, _preact.h)("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      props.saveCallback();
    }
  }, (0, _preact.h)(_InputGroup.default, {
    title: "Status Name",
    type: "text",
    required: true,
    onChange: function onChange(e) {
      return props.onCallback(_objectSpread(_objectSpread({}, props.data), {}, {
        name: e.target.value
      }));
    },
    value: props.data.name,
    qaClasses: "qa-ideation-name"
  }), (0, _preact.h)(_IdeationAddColor.default, {
    title: "Background Color",
    colors: props.colors,
    selectedColor: props.data.bgColor ? props.data.bgColor : props.colors[0],
    type: "bgColor",
    onCallback: function onCallback(newData) {
      return props.onCallback(_objectSpread(_objectSpread({}, props.data), newData));
    },
    qaClasses: "qa-ideation-bgColor"
  }), (0, _preact.h)(_IdeationAddColor.default, {
    title: "Text Color",
    colors: [],
    selectedColor: props.data.textColor ? props.data.textColor : '#ffffff',
    type: "textColor",
    onCallback: function onCallback(newData) {
      return props.onCallback(_objectSpread(_objectSpread({}, props.data), newData));
    },
    qaClasses: "qa-ideation-textColor"
  }), (0, _preact.h)("div", {
    className: "ideation-update-modal-footer"
  }, (0, _preact.h)("button", {
    disabled: props.isLoading,
    className: "btn btn-default",
    onClick: props.cancelCallback
  }, "Cancel"), (0, _preact.h)("button", {
    disabled: props.isLoading,
    className: "btn btn-primary ".concat(props.isLoading ? 'is--loading' : '')
  }, (0, _preact.h)("div", {
    className: "btn--loader"
  }), (0, _preact.h)("span", {
    className: "btn__hide-when-loading"
  }, "Save")))));
};

var _default = IdeationAddEdit;
exports.default = _default;